// extracted by mini-css-extract-plugin
export var actionButton = "_om-0";
export var actionMenuContainer = "_om-i";
export var bubble = "_om-2";
export var bubbleActionMenu = "_om-j";
export var bubbleContext = "_om-6";
export var bubbleItems = "_om-7";
export var customer = "_om-3";
export var divider = "_om-8";
export var fileList = "_om-9";
export var hiddenComment = "_om-o";
export var infoAbove = "_om-a";
export var internal = "_om-4";
export var lightActionButton = "_om-1";
export var link = "_om-b";
export var merchant = "_om-5";
export var message = "_om-c";
export var profilePicture = "_om-e";
export var quillToolbarContainer = "_om-f";
export var senderDate = "_om-g";
export var senderDateCustomer = "_om-h";
export var senderName = "_om-d";
export var time = "_om-k";
export var uploadedImage = "_om-l";
export var username = "_om-m";
export var xsmall = "_om-n";